import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mayo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errText(detail) {
  if (detail == null) return "Что-то пошло не так. Попробуйте снова.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const fmtUSD = (v) =>
  new Intl.NumberFormat("ru-RU", { style: "currency", currency: "USD", maximumFractionDigits: 0 })
    .format(Number(v || 0));

export const fmtUSD2 = (v) =>
  new Intl.NumberFormat("ru-RU", { style: "currency", currency: "USD", minimumFractionDigits: 2 })
    .format(Number(v || 0));

export const fmtAmount = (v, currency) =>
  `${new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 }).format(Number(v || 0))} ${currency || ""}`.trim();

export const fmtDate = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

export const TYPE_LABEL = { income: "Доход", transfer: "Перевод", expense: "Расход" };
export const FREQ_LABEL = {
  once: "Разово", daily: "Каждый день", weekly: "Каждую неделю",
  monthly: "Каждый месяц", quarterly: "Каждый квартал", custom: "Ручной период",
};
export const CURRENCIES = ["USD", "EUR", "RUB", "KZT", "AED", "GBP", "TRY", "CNY"];

export async function downloadFile(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
